<template>
  <el-card
    shadow="nerver"
    class="box-card"
    :body-style="{padding: 0}"
  >
    <el-row class="box-card-contentContainer">
      <el-col
        :span="18"
        class="box-card-content cs-fullHeight"
      >
        <el-row>
          <el-col :span="6">
            <span>优惠政策: </span>
          </el-col>
          <el-col :span="18">
            <div
              v-for="(item, index) in dataModel.discounts"
              :key="index"
            >
              <span>{{item}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>占位课数: </span>
          </el-col>
          <el-col :span="18">
            <span>{{dataModel.aeCount}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>占位价格: </span>
          </el-col>
          <el-col :span="18">
            <span>{{dataModel.totalPrice | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row v-if="!!dataModel.buyMemberCardPrice">
          <el-col :span="6">
            <span>购买会员: </span>
          </el-col>
          <el-col :span="18">
            <span>{{dataModel.buyMemberCardPrice | toCurrency}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>合同: </span>
          </el-col>
          <el-col :span="18">
            <span>{{dataModel.contractName}}</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col
        :span="6"
        class="box-card-subtotal cs-fullHeight"
      >
        <div class="subtotal-content">
          <el-row>
            <el-col>
              <span>小计</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>{{(dataModel.discountPrice + dataModel.buyMemberCardPrice) | toCurrency}}</el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<style lang="scss" scoped>
.box-card {
  background-color: #f5f7fa;

  .box-card-contentContainer {
    height: 200px;
    min-height: 200px;

    .box-card-content {
      padding: 20px;
    }

    .box-card-subtotal {
      padding: 20px;
      background-color: #e1edf7;
      display: table;
      text-align: center;

      .subtotal-content {
        display: table-cell;
        vertical-align: middle;
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    data: {
      discounts: Array,
      aeCount: Number,
      totalPrice: Number,
      discountPrice: Number,
      buyMemberCardPrice: Number,
      contractName: String
    }
  },
  data() {
    return {
      dataModel: {
        discounts: [],
        aeCount: 0,
        totalPrice: 0,
        discountPrice: 0,
        buyMemberCardPrice: 0,
        contractName: null
      }
    };
  },
  components: {},
  computed: {},
  created() {
    this.reloadDataModel();
  },
  methods: {
    reloadDataModel(data) {
      if (!data) data = this.data;

      if (!!data) {
        this.dataModel.discounts = $.extend(true, [], data.discounts);
        this.dataModel.aeCount = this.data.aeCount;
        this.dataModel.totalPrice = this.data.totalPrice;
        this.dataModel.discountPrice = this.data.discountPrice;
        this.dataModel.buyMemberCardPrice = this.data.buyMemberCardPrice;
        this.dataModel.contractName = this.data.contractName;
      } else {
        this.dataModel.discounts = [];
        this.dataModel.aeCount = 0;
        this.dataModel.totalPrice = 0;
        this.dataModel.discountPrice = 0;
        this.dataModel.buyMemberCardPrice = 0;
        this.dataModel.contractName = null;
      }
    }
  },
  watch: {
    data: function(newVal) {
      this.reloadDataModel(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/advanceEnrollmentFee/aefWorkflowCard.vue